<template>
    <div>
        <div>
            <label for="" class="form--label">{{ $t('words.chatting_download_fields') }}</label>
            <div class="form-checkbox" :key="field.name" v-for="field in filtered">
                <input type="checkbox" :id="field.name" v-model="field.selected">
                <label :for="field.name">{{ field.name }}</label>
            </div>
        </div>
        <div class="mt-sp">
            <label for="" class="form--label">{{  $t('words.chatting_download_file_type') }}</label>
            <div class="form-radio">
                <input type="radio" name="ext" value="csv" class="form-check-input" v-model="downloadExt" id="downloadExt-csv">
                <label for="downloadExt-csv" >csv</label>
            </div>
            <div class="form-radio">
                <input type="radio" name="ext" value="xlsx" class="form-check-input" v-model="downloadExt" id="downloadExt-xlsx">
                <label for="downloadExt-xlsx" >xlsx</label>
            </div>
        </div>
        <a class="btn btn-primary mt-sp" :href="downloadLink"><i class="icon icon-download"></i>{{ $t('words.download') }}</a>
    </div>
</template>
<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        broadcast: {},
        open: {
            type: [Boolean],
            require: true,
        },
    },
    data() {
        return {
            filtered: {},
            downloadLink: '',
            downloadExt: '',
        };
    },
    mounted() {
        // this.getDownloadExt();
        // this.getFilteredDownloadFiltered();
    },
    methods: {
        getDownloadExt() {
            const chatFileExt = localStorage.getItem('chatting_download_ext');
            // this.downloadExt = '';
            if (!_.isEmpty(chatFileExt)) {
                this.downloadExt = chatFileExt === 'csv' ? 'csv' : 'xlsx';
            } else {
                this.downloadExt = 'xlsx';
            }
        },
        getFilteredDownloadFiltered() {
            let localFiltered = localStorage.getItem('chat_filtered');
            if (this.broadcast.chatting_scalable) {
                localFiltered = localStorage.getItem('scalable_chat_filtered');
            }
            if (!_.isEmpty(localFiltered)) {
                this.filtered = JSON.parse(localFiltered);
            } else {
                this.filtered = this.chattingDownloadFields.map(field => ({ name: field, selected: 1 }));
            }
        },
        getExportUrl() {
            const filtered = this.filtered.filter(field => field.selected)
                .map(field => field.name);

            if (filtered.length === 0) {
                return false;
            }
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/broadcasts/${this.broadcast.id}/chatting-download?filtered=${filtered.join('||')}&ext=${this.downloadExt}`;
        },
        changeDownloadExt() {
            localStorage.setItem('chatting_download_ext', this.downloadExt);
            this.downloadLink = this.getExportUrl();
        },
    },
    computed: {
        chattingDownloadFields() {
            if (this.broadcast.chatting_scalable) {
                if (this.getConfig && 'chatting_scalable_download_fields' in this.getConfig) {
                    return this.getConfig.chatting_scalable_download_fields;
                }
            }
            if (this.getConfig && 'chatting_download_fields' in this.getConfig) {
                return this.getConfig.chatting_download_fields;
            }
            return {};
        },
    },
    watch: {
        filtered: {
            handler(newValue) {
                if (!_.isEmpty(this.filtered)) {
                    // const filtered = this.filtered.filter(field => field.selected)
                    //     .map(field => field.name);
                    if (this.broadcast.chatting_scalable) {
                        localStorage.setItem('scalable_chat_filtered', JSON.stringify(this.filtered));
                    } else {
                        localStorage.setItem('chat_filtered', JSON.stringify(this.filtered));
                    }
                    this.downloadLink = this.getExportUrl();
                    // this.downloadLink = `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/broadcasts/${this.broadcast.id}/chatting-download?filtered=${filtered.join('||')}&ext=${this.downloadExt}`;
                }
            },
            deep: true,
            immediate: true,
        },
        open(newValue, oldValue) {
            if (newValue !== oldValue && newValue === true) {
                this.getDownloadExt();
                this.getFilteredDownloadFiltered();
            } else {
                this.downloadExt = '';
                this.filtered = {};
            }
        },
        downloadExt(newValue, oldValue) {
            if (oldValue !== '' && newValue !== '' && newValue !== oldValue) {
                this.changeDownloadExt();
            }
        },
    },
};
</script>
